/* unplugin-vue-components disabled */import { render } from "./mobile.vue?vue&type=template&id=f0ab0dc8&scoped=true&ts=true"
import script from "./mobile.vue?vue&type=script&lang=ts"
export * from "./mobile.vue?vue&type=script&lang=ts"

import "./mobile.vue?vue&type=style&index=0&id=f0ab0dc8&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ab0dc8"]])

export default __exports__